import { useState } from "react";
import { useForm } from "react-hook-form";
import { useTranslation } from "react-i18next";

export interface EditJobProps {
  state: {
    isModalOpen: any;
    setModalOpen: any;
  };
  description: string;
  onEdit: any;
  title: string;
  className?: string;
}

const EditJob: React.FC<EditJobProps> = ({
  state,
  description,
  onEdit,
  title,
}) => {
  const {
    control,
    handleSubmit,
    register,
    formState: { dirtyFields },
  } = useForm({
    defaultValues: {
      description,
    },
  });

  const { t } = useTranslation();

  const [isModalOpen, setModalOpen] = useState<boolean>(false);

  return (
    <>
      {/* <AcedModal
        state={state}
        title={title}
        onClose={dirtyFields.description ? () => setModalOpen(true) : null}
      >
        <form
          onSubmit={handleSubmit((data: any) => onEdit(data.description))}
          className="edit-modal"
        >
          <AcedTextArea
            // defaultText={description}
            register={register("description")}
          />
          <Button className="btn btn-primary">
            {t("common.buttons.save")}
          </Button>
        </form>
      </AcedModal>
      {isModalOpen && (
        <ConfirmationModal
          title={t("common.messages.unsavedWarning")}
          state={{ isModalOpen, setModalOpen }}
          onConfirm={() => {
            state.setModalOpen(false);
            setModalOpen(false);
          }}
        />
      )} */}
    </>
  );
};

export default EditJob;
